module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "totals-container"
  }, [_c('el-col', {
    attrs: {
      "xs": {
        span: 24,
        offset: 0
      },
      "sm": {
        span: 12,
        offset: 12
      }
    }
  }, _vm._l((_vm.list), function(item, i) {
    return _c('el-row', {
      key: i,
      staticClass: "summary",
      class: {
        'summary--total': i === _vm.list.length - 1
      }
    }, [_c('el-col', {
      staticClass: "cell-heading",
      attrs: {
        "span": 12
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('el-col', {
      staticClass: "cell-content",
      attrs: {
        "span": 12
      }
    }, [_vm._v(_vm._s(item.value))])], 1)
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b108d8b","hasScoped":false}!./src/app/components/totalsTable/totalsTable.html
// module id = 2949
// module chunks = 1